import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withInMemoryScrolling, withPreloading, withRouterConfig } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { FlaggedPreloadingStrategy } from './core/routing/flagged-preloading.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // anchorScrolling: the header's nav links navigate to "/" with a fragment,
    // and this is what makes the router scroll to that element.
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      // A link to the page you are already on ("Home" on home, a section you
      // scrolled away from) still runs, so the scroll above happens again.
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      // Fetches the booking page's code in the background (see the strategy).
      withPreloading(FlaggedPreloadingStrategy),
    ),

    // Order matters: the token is attached first, loading then wraps the
    // whole lifecycle, and error handling sits closest to the response.
    provideHttpClient(
      // No base-url interceptor: BaseApiService joins API_BASE_URL to the
      // endpoint path, and prefixing in two places would double the host.
      withInterceptors([authTokenInterceptor, loadingInterceptor, errorInterceptor]),
    ),

    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          // The landing page is designed light-only (see color-scheme in
          // styles.css), so don't let PrimeNG follow the OS dark preference.
          darkModeSelector: false,
        },
      },
    }),

    // Backs NotificationService and the <p-toast /> in the app shell.
    MessageService,
  ],
};
